import { createEntitySlice } from '@/shared/store/createEntitySlice';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { paymentRetriesApi } from '../api';
import type { PaymentRetry, PaymentRetryFilters } from '../types';

const initialState = {
  items: [] as PaymentRetry[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    shopifyCustomerId: '',
  } as PaymentRetryFilters,
};

const { actions, reducer } = createEntitySlice<
  PaymentRetry,
  PaymentRetryFilters,
  Partial<PaymentRetry>
>({
  name: 'paymentRetries',
  api: paymentRetriesApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.paymentRetries;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search && filters.search.trim()) {
      params.shopifyCustomerId = filters.search.trim();
    }

    return params;
  },
});

export const {
  fetchItems: fetchPaymentRetries,
  setPage,
  setPerPage,
  setFilters,
  updateItem,
} = actions;

export const cancelPaymentRetry = createAsyncThunk(
  'paymentRetries/cancel',
  async (id: number, { dispatch }) => {
    await paymentRetriesApi.update(id);
    await dispatch(fetchPaymentRetries());
    return id;
  },
);

export { reducer };
